import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { HttpClientModule ,HTTP_INTERCEPTORS } from '@angular/common/http';
//spinner
import { NgHttpLoaderModule } from 'ng-http-loader';
import { HttpService } from './services/http.service';
import { TokenDecodeService } from './services/token-decode.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TokenInterceptor } from './services/token.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { CustomToastComponent } from './component/custom-toast/custom-toast.component';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';

const dbConfig: DBConfig  = {
  name: 'MarketplaceDB',
  version: 1,
  objectStoresMeta: [{
    store: 'Categories',
    storeConfig: { keyPath: null, autoIncrement: true },
    storeSchema: []
  }]
};

@NgModule({
  declarations: [
    AppComponent,
    CustomToastComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      toastComponent: CustomToastComponent,
      positionClass: "toast-bottom-right",
      closeButton: true
    }),
    HttpClientModule,
    NgxIndexedDBModule.forRoot(dbConfig),    
    NgHttpLoaderModule.forRoot(),
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },HttpService,TokenDecodeService],
  bootstrap: [AppComponent]
})
export class AppModule { }
